export default __webpack_public_path__ + "static/media/whitepaper_kor.fd43f2b1.pdf";